import {faEdit, faTrash} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Modal} from 'antd';

import {useLocale} from '../../../../provider/locale/locale-hook';
import {useDeleteEvent} from '../../../../service/events/events-hook';
import {CommonEventStatusEnum, EventListItemType} from '../../../../service/events/events-type';

type EventActionsPropsType = {
    event: EventListItemType;
    onEdit: (eventId: number) => void;
};

export function EventActions({event, onEdit}: EventActionsPropsType): JSX.Element {
    const {getLocalizedString} = useLocale();
    const deleteEvent = useDeleteEvent();

    const isDeleted = event.status === CommonEventStatusEnum.Deleted;

    function handleDelete(): void {
        Modal.confirm({
            title: getLocalizedString('EVENTS__CONFIRM__DELETE__TITLE'),
            content: getLocalizedString('EVENTS__CONFIRM__DELETE__DESCRIPTION'),
            okType: 'danger',
            onOk: () => deleteEvent.mutate(event.id),
        });
    }

    return (
        <div style={{display: 'flex', gap: 4}}>
            <Button
                disabled={isDeleted}
                icon={<FontAwesomeIcon icon={faEdit} />}
                onClick={() => onEdit(event.id)}
                size="small"
                type="text"
            />
            <Button
                danger
                disabled={isDeleted}
                icon={<FontAwesomeIcon icon={faTrash} />}
                loading={deleteEvent.isLoading}
                onClick={handleDelete}
                size="small"
                type="text"
            />
        </div>
    );
}
